import { render } from "./LimitStudentPass.vue?vue&type=template&id=45f92994"
import script from "./LimitStudentPass.vue?vue&type=script&lang=js"
export * from "./LimitStudentPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__